/* Belterbox — localisation: footer selector + "shopping from the UK?" nudge.

   Why this exists (2026-09-23): Shopify only auto-detects a visitor's country on the Plus plan.
   belterbox is on Basic, so without this a GB/US/AU visitor lands on the primary (EUR) market and
   never discovers their own currency -- which is ~66% of orders. Markets alone would be invisible.

   Rules, taken from Shopify's own localization-discovery guidance:
   - NEVER auto-redirect. Suggest; let the visitor choose. Auto-redirecting hijacks people who meant
     to browse in another currency, and mangles SEO crawlers, which come mostly from US IPs.
   - Build the bar in JS and append it after load -> zero layout shift, nothing for bots to index.
   - Remember a dismissal. Don't nag.
   - Degrade to nothing on any error: this must never block a purchase.
*/
(function () {
  'use strict';

  var S = window.Shopify || {};
  var ROOT = (S.routes && S.routes.root) || '/';
  var HERE = S.country || '';
  var KEY = 'bb_geo_dismissed';

  function get(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function set(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* private mode */ } }

  /* Submit the localization form the way Shopify expects (POST + _method=PUT). */
  function switchTo(code) {
    var f = document.createElement('form');
    f.method = 'POST';
    f.action = ROOT + 'localization';
    f.hidden = true;
    [['form_type', 'localization'], ['utf8', '✓'], ['_method', 'PUT'],
     ['country_code', code], ['return_to', window.location.pathname + window.location.search]]
      .forEach(function (kv) {
        var i = document.createElement('input');
        i.type = 'hidden'; i.name = kv[0]; i.value = kv[1];
        f.appendChild(i);
      });
    document.body.appendChild(f);
    f.submit();
  }

  /* ---- 1. footer selector: submit on change, hide the no-JS button ---------------------- */
  function wireSelector() {
    var sel = document.querySelector('[data-bb-locale-select]');
    if (!sel) return;
    var form = sel.closest('form');
    if (!form) return;
    var go = form.querySelector('[data-bb-locale-go]');
    if (go) go.hidden = true;
    sel.addEventListener('change', function () { switchTo(sel.value); });
  }

  /* browsing_context_suggestions.json returns the country but NOT its currency, and the whole
     point of the nudge is to name the currency. So Liquid hands us a map of the enabled
     countries -> their currency, rendered in the footer. */
  function currencyMap() {
    var el = document.querySelector('[data-bb-geo-map]');
    if (!el) return {};
    try { return JSON.parse(el.textContent || '{}'); } catch (e) { return {}; }
  }

  /* ---- 2. the nudge ---------------------------------------------------------------------- */
  function bar(country) {
    var cur = currencyMap()[country.handle] || {};
    var wrap = document.createElement('div');
    wrap.className = 'bb-geo';
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', 'Change country and currency');

    var msg = document.createElement('p');
    msg.className = 'bb-geo__msg';
    msg.textContent = 'shopping from ' + country.name + '?';

    var go = document.createElement('button');
    go.type = 'button';
    go.className = 'bb-geo__go';
    go.textContent = cur.c ? ('switch to ' + cur.c + (cur.s ? ' ' + cur.s : '')) : ('switch to ' + country.name);
    go.addEventListener('click', function () { set(KEY, HERE); switchTo(country.handle); });

    var no = document.createElement('button');
    no.type = 'button';
    no.className = 'bb-geo__no';
    no.setAttribute('aria-label', 'Dismiss');
    no.textContent = 'stay in ' + (S.currency && S.currency.active ? S.currency.active : 'EUR');
    no.addEventListener('click', function () { set(KEY, HERE); wrap.remove(); });

    wrap.appendChild(msg); wrap.appendChild(go); wrap.appendChild(no);
    document.body.appendChild(wrap);
    place(wrap);
    requestAnimationFrame(function () { wrap.classList.add('is-in'); });

    /* Shopify's cookie-consent banner is also bottom-fixed and sits above us, swallowing the
       click -- and it is showing for exactly the first-time visitors this bar is aimed at.
       Found by a real browser test on 2026-09-23; curl cannot see it. So sit ABOVE the banner
       while it is there and drop back down once it is dismissed. Never fight it for z-index:
       covering a consent dialog is both hostile and legally dubious. */
    var settle = setInterval(function () {
      if (!document.body.contains(wrap)) { clearInterval(settle); return; }
      place(wrap);
    }, 700);
    setTimeout(function () { clearInterval(settle); }, 60000);
  }

  /* Keep the bar clear of any bottom-fixed consent dialog.
     NB: do NOT test visibility with offsetParent here -- it is always null for a
     position:fixed element, which is exactly what a consent dialog is. That bug shipped
     once and left the bar sitting underneath the banner anyway. Measure the rect. */
  function place(wrap) {
    var gap = 16;
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var banner = document.querySelector('#shopify-pc__banner, .shopify-pc__banner');
    if (banner) {
      var cs = window.getComputedStyle(banner);
      var r = banner.getBoundingClientRect();
      var shown = cs.display !== 'none' && cs.visibility !== 'hidden' &&
                  parseFloat(cs.opacity || '1') > 0.05 && r.height > 0;
      /* only dodge it if it actually occupies the bottom of the viewport */
      if (shown && r.bottom > vh - 24 && r.top < vh) {
        gap = Math.round(vh - r.top) + 24;
      }
    }
    wrap.style.bottom = gap + 'px';
  }

  function suggest() {
    if (!HERE || get(KEY) === HERE) return;
    var url = ROOT + 'browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' +
      encodeURIComponent(HERE);
    fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.suggestions || !d.suggestions.length) return;
        var parts = d.suggestions[0].parts || {};
        var c = parts.country;
        if (!c || !c.handle || c.handle === HERE) return;
        if (!currencyMap()[c.handle]) return;
        bar(c);
      })
      .catch(function () { /* stay silent; never block the page */ });
  }

  function init() { try { wireSelector(); suggest(); } catch (e) { /* inert on error */ } }

  /* after load, so the nudge never competes with LCP */
  if (document.readyState === 'complete') init();
  else window.addEventListener('load', init);
})();
